import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import AuthShell from './AuthShell';
import { history } from '../../history';
import { AlertAction, AuthAction } from '../../actions';
import RLib from '../../components/common/RLib';

const ForgotPassword = ({ AlertError, AlertOk }) => {

    const [ t ] = useTranslation();
    const [ sessionKey, setSessionKey] = useState("");
    // U-48: 링크 상태 — '' 정상 / 'expired'(서버 EA0007) / 'invalid'(서버 EA0006 또는 주소 형식 오류)
    const [ linkError, setLinkError ] = useState("");
    const [ submitting, setSubmitting ] = useState(false);
    const [ inputs, setInputs ] = useState({ password : "", passwordCheck : "" });
    const { password, passwordCheck } = inputs;

    useEffect(() => {
        document.body.className = "animsition page-forgot-password layout-full";
        getUrlKey();
    }, []);

    const getUrlKey = () => {
        const nKey = location.search;
        if(nKey.indexOf('key=') == -1){
            setLinkError('invalid'); return;
        }
        if(nKey.replace('?key=', '').length != 10){
            setLinkError('invalid'); return;
        }
        setSessionKey(nKey.replace('?key=', ''));
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInputs(inputs => ({ ...inputs, [name]: value }));
    }

    const handleButtonClick = (e) => {
        if(e && e.preventDefault) e.preventDefault();
        if(submitting) return;
        if(!RLib.ValidatePasswordStrength(password)){
            // U-04: 서버는 규칙을 검사하지 않으므로 화면에서 먼저 막고 실제 규칙을 안내한다
            AlertError(t('auth.message.passwordCreateComment'));
        }else if(password != passwordCheck){
            AlertError(t('auth.message.error.checkPassword'));
        }else{
            setSubmitting(true);
            AuthAction.UpdatePasswordByForgot({...inputs, key : sessionKey}).then((ret) => {
                if(ret?.status == "success"){
                    // U-30: 성공하면 안내 후 로그인 화면으로 이동
                    AlertOk(t('auth.message.info.passwordResetDone'));
                    history.replace("/Login");
                }else{
                    setSubmitting(false);
                    if(ret?.errmsg == 'EA0007') setLinkError('expired');
                    else if(ret?.errmsg == 'EA0006') setLinkError('invalid');
                    else AlertError(ret?.err);
                }
            }).catch(() => setSubmitting(false));
        }
    }

    if(linkError){
        return (
            <AuthShell title={t('auth.button.resetPassword')}>
                <p className="rg-login-err-msg" role="alert" style={{ marginTop: 0, marginBottom: 18, fontSize: 14.5 }}>{linkError == 'expired' ? t('auth.message.error.resetLinkExpired') : t('auth.message.error.resetLinkInvalid')}</p>
                <Link to="/ForgotPassword" className="rg-login-btn-signin">{t('auth.button.resendResetLink')}</Link>
                <div className="rg-login-row-between" style={{ justifyContent: 'center', margin: '18px 0 0' }}>
                    <Link to="/Login" className="rg-login-link">Back to login</Link>
                </div>
            </AuthShell>
        )
    }

    return (
        <AuthShell title={t('auth.button.resetPassword')} description="Please enter your new password.">
            <form method="post" role="form" autoComplete="off" onSubmit={handleButtonClick}>
                <div className="rg-login-field">
                    <label htmlFor="rg-reset-password">{t('common.field.password')}</label>
                    <div className="rg-login-input-wrap">
                        <input id="rg-reset-password" type="password" value={password} name="password" onChange={handleInputChange} />
                    </div>
                </div>
                <div className="rg-login-field">
                    <label htmlFor="rg-reset-password-check">{t('auth.field.retypePassword')}</label>
                    <div className="rg-login-input-wrap">
                        <input id="rg-reset-password-check" type="password" value={passwordCheck} name="passwordCheck" onChange={handleInputChange} />
                    </div>
                </div>
                <button type="submit"
                    disabled={submitting}
                    className="rg-login-btn-signin">{t('auth.button.resetPassword')}</button>
            </form>
            <div className="rg-login-row-between" style={{ justifyContent: 'center', margin: '18px 0 0' }}>
                <Link to="/Login" className="rg-login-link">Back to login</Link>
            </div>
        </AuthShell>
    )
}

const mapDispatch = dispatch => ({
    AlertError : message => dispatch(AlertAction.Error(message)),
    AlertOk : message => dispatch(AlertAction.Success(message)),
})

export default connect(null, mapDispatch)(ForgotPassword);